var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.47643 8.00164C6.47643 7.16007 7.15866 6.47784 8.00023 6.47784C8.8418 6.47784 9.52403 7.16007 9.52403 8.00164C9.52403 8.84321 8.8418 9.52544 8.00023 9.52544C7.15866 9.52544 6.47643 8.84321 6.47643 8.00164Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7044 8.86539C16.0988 8.35023 16.0988 7.65364 15.7044 7.13764C14.4618 5.51559 11.4807 2.17578 8.00023 2.17578C4.51977 2.17578 1.53866 5.51559 0.296117 7.13764C0.104187 7.38471 0 7.68866 0 8.00152C0 8.31437 0.104187 8.61832 0.296117 8.86539C1.53866 10.4874 4.51977 13.8273 8.00023 13.8273C11.4807 13.8273 14.4618 10.4874 15.7044 8.86539ZM8.00023 4.95404C6.31709 4.95404 4.95263 6.3185 4.95263 8.00164C4.95263 9.68478 6.31709 11.0492 8.00023 11.0492C9.68338 11.0492 11.0478 9.68478 11.0478 8.00164C11.0478 6.3185 9.68338 4.95404 8.00023 4.95404Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.5122de47791d4d983c3d22be62ae8535.svg";
export { ForwardRef as ReactComponent };